import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Dict } from '../types/decorable';
import { ModalConfirmMsg } from '../types/modalconfirmmsg';
import { ModalProgMsg } from '../types/modalprogmsg';
import { ModalNotice } from '../types/modalnotice';
import { SimpleHandler, DictHandler } from '../types/@types/sl-v-types';
// import * as $ from 'jquery';
import { ModalCompressedFileRequestMessage, ModalFileRequestMessage } from '../types/modalfilerequestmessage';
import { ModaLRemoteCtrlMessage } from '../types/modall-remote-ctrl-message';
import { ModalFileDownloadRequestMessage } from '../types/modal-file-download-request';
import { MessageOption } from './modal-messager.component';
import { ModalPasteRequestMessage } from '../types/modal-paste-request';
import { ModalCopyRequestMessage } from '../types/modal-copy-request';

@Injectable({
  providedIn: 'root'
})
export class ModalMessagerService {
  public remoteCtrl$: Subject<ModaLRemoteCtrlMessage>;
  public notify$: Subject<ModalNotice>;
  public progress$: Subject<ModalProgMsg>;
  public confirm$: Subject<ModalConfirmMsg>;
  public cancellation$: Subject<Dict>;
  public importRequest$: Subject<ModalFileRequestMessage>;
  public exportRequest$: Subject<ModalFileRequestMessage>;
  public compressedExportRequest$: Subject<ModalCompressedFileRequestMessage>;
  public downloadRequest$: Subject<ModalFileRequestMessage>;
  public pasteRequest$: Subject<ModalPasteRequestMessage>;
  public copyRequest$: Subject<ModalCopyRequestMessage>;

  constructor() {
    this.remoteCtrl$ = new Subject<ModaLRemoteCtrlMessage>();
    this.notify$ = new Subject<ModalNotice>();
    this.progress$ = new Subject<ModalProgMsg>();
    this.cancellation$ = new Subject<Dict>();
    this.confirm$ = new Subject<ModalConfirmMsg>();
    this.importRequest$ = new Subject<ModalFileRequestMessage>();
    this.compressedExportRequest$ = new Subject<ModalCompressedFileRequestMessage>();
    this.exportRequest$ = new Subject<ModalFileRequestMessage>();
    this.downloadRequest$ = new Subject<ModalFileRequestMessage>();
    this.pasteRequest$ = new Subject<ModalPasteRequestMessage>();
    this.copyRequest$ = new Subject<ModalCopyRequestMessage>();
  }

  Notify(
    displayMessage: string,
    warn: boolean = false,
    optTitle: string = 'Notice'): void {
    const message: ModalNotice = {
      type: 'notice',
      message: displayMessage,
      title: optTitle,
      asWarning: warn
    };
    this.notify$.next(message);
  }

  Progress(
    displayMessage: string,
    isCancelable: boolean,
    optPercent: number = NaN,
    optTitle: string = 'Progress Notice',
    optCancelHandler: DictHandler = null) {
    const message: ModalProgMsg = {
      type: 'progress',
      message: displayMessage,
      title: optTitle,
      progress: optPercent,
      cancelable: isCancelable,
      cancelHandler: optCancelHandler
    };
    this.progress$.next(message);
  }
  CancelProgress(progTitle: string): void {
    this.cancellation$.next({ title: progTitle });
  }
  Confirm(
    displayMessage: string,
    optOkHandler: SimpleHandler | DictHandler | null,
    optCancelHandler: SimpleHandler | DictHandler | null,
    optTitle: string = 'Confirmation Notice', options: Array<MessageOption> | null = null) {


    const message: ModalConfirmMsg = {
      type: 'confirm',
      message: displayMessage,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    if (options !== null) {
      message.options = options;
    }
    this.confirm$.next(message);

  }
  RequestImport(
    readParams: {
      acceptedExtentions: Array<string>
      readType?: 'string' | 'buffer' | 'dataURL' | 'text';
      encoding?: string;
    },
    displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Import File ...'
  ) {
    const message: ModalFileRequestMessage = {
      type: 'request-import',
      message: displayMessage,
      title: optTitle,
      acceptedExts: readParams.acceptedExtentions,
      readType: !!readParams.readType ? readParams.readType : null,
      encoding: !!readParams.encoding ? readParams.encoding : null,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.importRequest$.next(message);
  }
  RequestCompressedExport(writeParams: Array<{
    extension: string;
    mimeType: string;
    contents: any;
    defaultFileName?: string;
  }>, displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Import/Export File ...') {
    const message: ModalCompressedFileRequestMessage = {
      type: 'request-compressed-export',
      message: displayMessage,
      contents: writeParams,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.compressedExportRequest$.next(message);

  };

  RequestExport(
    writeParams: {
      extension: string;
      mimeType: string;
      contents: any;
      defaultFileName?: string;
    },
    displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Import/Export File ...'
  ) {
    const message: ModalFileRequestMessage = {
      type: 'request-export',
      message: displayMessage,
      acceptedExts: [writeParams.extension],
      defaultFileName: (writeParams.defaultFileName),
      encoding: writeParams.mimeType,
      contents: writeParams.contents,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.exportRequest$.next(message);
  }
  RequestDownload(
    writeParams: {
      extension: string;
      mimeType: string;
      defaultFileName?: string;
    },
    wapiURL: string,
    wapiParams: any,
    displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Download File ...'
  ) {
    const message: ModalFileDownloadRequestMessage = {
      type: 'request-download',
      message: displayMessage,
      acceptedExts: [writeParams.extension],
      defaultFileName: (writeParams.defaultFileName),
      wapiURL: (wapiURL),
      mimeType: writeParams.mimeType,
      params: wapiParams,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.downloadRequest$.next(message);
  }
  RequestPaste(
    displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Paste Content') {
    const message: ModalPasteRequestMessage = {
      type: 'request-paste',
      message: displayMessage,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.pasteRequest$.next(message);
  }
  RequestCopy(
    displayMessage: string,
    content: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Copy Content') {
    const message: ModalCopyRequestMessage = {
      type: 'request-copy',
      content: content,
      message: displayMessage,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.copyRequest$.next(message);
  }

  Ok(title: string) {
    const message: ModaLRemoteCtrlMessage = {
      cmd: 'ok',
      message: '',
      title: (title),
      type: 'remote-ctrl'
    }
    this.remoteCtrl$.next(message);
  }
  Cancel(title: string, reason?: string) {
    const message: ModaLRemoteCtrlMessage = {
      cmd: 'cancel',
      message: reason,
      title: (title),
      type: 'remote-ctrl'
    }
    this.remoteCtrl$.next(message);
  }

}
